'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.screensaver.show', [])
  .controller('ScreenSaverShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/screenSaver/show/index.js